module.exports = __webpack_public_path__ + "static/iso27001-47c1179264416d856873379e77d83784.png";